const ROUTE_PARAMS = {
    MESSAGE_ID: 'messageId',
    DEVICE_TYPE: 'deviceType',
};

export default ROUTE_PARAMS;
